module.exports = __webpack_public_path__ + "img/ic_alipay_payment-method-dark.9beeab9.svg";